import { render } from "./AccountDetails.vue?vue&type=template&id=33a47110"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__